











































































import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';
import MyNav from '@/components/nav/Index.vue'; // nav
import MyDialog from '@/components/dialog/Index.vue'; // dialog
import { Button, Message, Scrollbar } from 'element-ui';
import NProgress from 'nprogress';
import decisive from '@/servers/modules/decisive/index'; // server
import Study from '@/servers/modules/decisive/study'; // server
import Rank from '@/views/decisive/ranking.vue';
import { Howl, Howler } from 'howler';
import Swiper from '@/components/swiper/swiper.vue';

    @Component({
      components: {        
        MyNav,
        MyDialog,
        Button,
        Swiper,
        Scrollbar,
        Rank,
      },
    })
export default class extends Vue {
  // ====================================数据====================================

    // 本地缓存基础数据-课程名称
    @Getter public basicData: any;

    // 左侧菜单栏
    @Getter public scaleCommonIndex: any;

    @Mutation public openDialog:any;

    @Mutation public closeDialog: any;

    // 开始学习按钮文字
    private buttonText:string = '开始学习';

    // 判断学习进度
    private whether:boolean = true;

    // - 学习进度
    private XxId:string = '';

    // 暂存数据
    private temporaryStorageForm:any = '';


    // 顶部进度栏nav
    private info: any = [
      { title: '总进度', img: require('@/assets/images/ui-ete/ete-progress.png'), number: '' },
      { title: '总掌握度', img: require('@/assets/images/ui-ete/ete-master.png'), number: '' },
      { title: '总正确率', img: require('@/assets/images/ui-ete/ete-right.png'), number: '' },
    ];

    // 当前学习节点
    private startStudy: any = {};

    // 轮播数据源
    private data: any = {};

    private lengC: any = 0;

    private taskList2:any = []

    // swiper 参数
    private swiperOptions:any = {
      observer: false,
      observeParents: false,
      centeredSlides: false,
      watchSlidesProgress: false,
      slidesPerView: 'auto',
      on: {
        click() {
          // alert('你点了Swiper');
        },
        touchMove(event:Event) {
          // 你的事件
        },
        setTranslate() {
        },
        setTransition(transition:any) {
          for (let i = 0; i < this.slides.length; i++) {
            const slide = this.slides.eq(i);
            slide.transition(transition);
          }
        },
      },
    };

    // ====================================初始化====================================

    private created() {
      NProgress.start();
      this.init();
    }

    private async init() {
      let res = await decisive.getInfo();
      this.XxId = res.data.data.currentNodeId;
      console.log(res);
      window.LS.set('jse_data', res.data.data);
      res = await decisive.index();
      const { data } = res.data;
      NProgress.done();
      if (!data.isNormallyStudy) {
        this.buttonText = '完成全部任务';
        this.whether = false;
      }
      // 顶部进度栏百分比展示
      this.info[0].number = data.totalProgress;
      this.info[1].number = data.totalMasteryDegree;
      this.info[2].number = data.totalAccuracyRate;
      /**
        *  @params status 学习阶段状态
        *  status:0 未解锁
        *  status:1 已解锁未通过
        *  status:2 已解锁已通过
        *  status:3 跳过
        *  status:5 当前学习
        *  */
      /**
        * @description: swiper展示逻辑
        * @update (2020-09-23)
        * 将学习阶段按阶段展示，将学前测与学后测单独作为一个阶段，其余训练阶段为一个阶段
        * 每个阶段展示各自的进度：前测-训练单元1-训练单元2-后测 ； 后期可能会增加训练单元，目前固定为此四个
        *
        * */
      const eightGroup = []; // 训练阶段数组
      const group = []; // 每个训练阶段
      let j = 0;
      for (let i = 0; i < data.taskList.length; i++) {
        this.taskList2.push(data.taskList[i]);
        // 设置当前学习阶段
        if (data.taskList[i].status == 5) {
          let k = i;
          // 判断swiper中第一个出现的位置
          // a为判断第一组，后续进行计算，不同的分组进行添加删减
          const a = parseInt((i - 1) / 4);
          const { nodeName } = data.taskList[i];
          console.log(nodeName, k, a, i);
          if (nodeName == '学前评测') {
            k = i;
          } else if (nodeName == '学后评测') {
            k = i + a;
          } else if (nodeName == '训练1' || nodeName == '训练单元1') {
            k = i - 1 + a;
          } else if (nodeName == '训练2' || nodeName == '训练单元2' || nodeName == '后测') {
            k = i - 2 + a;
          } else if (nodeName == '前测') {
            k = i + a;
          }

          this.swiperOptions.initialSlide = k;
          this.startStudy = data.taskList[i];
        }
        if (data.taskList[i].nodeName === '前测') {
          const task = JSON.parse(JSON.stringify(data.taskList[i]));
          task.nodeTitle = 'milepost';
          this.taskList2.splice(i + j, 0, task);
          j++;
        }
      }
      if (this.swiperOptions.initialSlide == null) {
        this.swiperOptions.initialSlide = data.taskList.length + 1;
      }
      this.data = data;
      this.$nextTick(() => {
        this.$refs.swiper.init(this.swiperOptions);
      });
    }

    // 开始学习
    async goToStudy() {
      // 完成全部任务直接退出
      if (!this.whether) {
        return;
      }
      const resData = await Study.queryTemporaryStorage({});
      // 有暂存的内容
      if (resData.data.data) {
        const temporaryStorageForm = this.temporaryStorageForm = eval(`(${resData.data.data})`);
        console.log(temporaryStorageForm);
        // 暂存的内容是重练内容，打开模态框
        if (temporaryStorageForm.learnType != 'learn') {
          this.dialogOpen();
        } else {
          // 暂存内容是正常学习内容，直接进入到学习页面，
          this.$router.push({ name: 'sprintLearning', query: { nodeId: this.startStudy.nodeId, isRetraining: false } });
        }
      } else {
        // 没有暂存内容的
        this.$router.push({ name: 'sprintLearning', query: { nodeId: this.startStudy.nodeId, isRetraining: false } });
      }
    }

    // 回顾复习；弱项强化
    private async goToReport(type: number) {
      const route: any = {
        name: 'decisiveStudyReport',
        query: {
          classType: type,
        },
      };
      if (type == 1) {
        route.query.mastery = 1;
      }
      this.$router.push(route);
    }

    // 打开模态框
    private dialogOpen() {
      this.openDialog({
        visible: true,
        titleClose: true,
        titleIcon: false,
        footer: [
          {
            class: 'button-style-border',
            word: '取消',
          },
          {
            class: 'button-style-background',
            word: '进入暂存学习任务',
          },
        ],
      });
    }

    // 进入暂存学习任务
    private dialogHandle(index: any) {
      // 取消不进入到模态框
      if (index == 0) {
        this.closeDialog();
      } else {
        // 重练标识isAgain;
        this.closeDialog();
        if (this.temporaryStorageForm.learnType == 'exit') { // 拓展练习暂存
          this.$router.push({ name: 'sprintLearning', query: { nodeId: this.temporaryStorageForm.nodeId, isExit: true, isAgain: true } });
        } else if (this.temporaryStorageForm.learnType == 'exitReview') { // 拓展练习重练暂存
          this.$router.push({
            name: 'sprintLearning',
            query: {
              nodeId: this.temporaryStorageForm.nodeId, paperAssemItemType: this.temporaryStorageForm.paperAssemItemType, isExit: true, isAgain: true,
            },
          });
        } else if (this.temporaryStorageForm.learnType == 'strong') { // 弱项强化重练暂存
          this.$router.push({ name: 'sprintLearning', query: { nodeId: this.temporaryStorageForm.nodeId, paperAssemItemType: this.temporaryStorageForm.paperAssemItemType, isAgain: true } });
        } else {
          // 从正常学习入口进入，暂存内容，进入到正常学习路由内容
          this.$router.push({ name: 'sprintLearning', query: { nodeId: this.temporaryStorageForm.nodeId, isRetraining: false } });
        }
      }
    }
}
